class LaravelErrors {
	static getFirstErrorOnly (laravelErrors) {
		const errors = {};
		Object.keys(laravelErrors).forEach((key) => {
			errors[key] = laravelErrors[key][0];
		});
		return errors;
	}

	static getOneErrorTextOnly (laravelErrors) {
	  let error = null;
		Object.keys(laravelErrors).forEach((key) => {
			error = laravelErrors[key][0];
		});
		return error;
	}
}

export default LaravelErrors;
